import { OpenInNew } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography
} from '@mui/material';
import React from 'react';

export default function CompactStatCard({
  title,
  value,
  subtitle,
  icon,
  color = 'primary',
  onNavigate
}) {
  return (
    <Card
      sx={{
        height: '100%',
        backgroundColor: 'background.paper',
        minHeight: '140px',
        position: 'relative'
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <IconButton
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main'
            }
          }}
          size="small"
          onClick={onNavigate}
        >
          <OpenInNew fontSize="small" />
        </IconButton>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ pr: 4 }}
        >
          <Box flex={1}>
            <Typography
              variant="body2"
              color="textSecondary"
              gutterBottom
              sx={{ fontSize: '0.8rem' }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              component="div"
              color={color}
              sx={{ fontWeight: 'bold', mb: 0.5 }}
            >
              {value.toLocaleString()}
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {subtitle}
            </Typography>
          </Box>
          <Box sx={{ color: `${color}.main`, fontSize: 32, ml: 1 }}>
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
